module.exports = __webpack_public_path__ + "img/ShieldCheck.3d38639f.svg";